import Tooltip from 'bootstrap/js/dist/tooltip';

const tooltips = {

	defaultTarget: document.querySelector('body'),

	/**
	 * Init
	 *
	 * @param {object} target
	 *
	 * @returns {void}
	 */
	init: function(target = tooltips.defaultTarget) {

		window.app.domStateReady(function() {

			const tooltipTriggerList = target.querySelectorAll('[data-bs-toggle="tooltip"]');
			[...tooltipTriggerList].map(tooltipTriggerEl => new Tooltip(tooltipTriggerEl));

		});

	}
};

export default tooltips;
